import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumQRCodeType } from '@models/Common';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { StringUtils } from '@utils/StringUtils';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


@Component({
    selector: 'app-consumer-identification',
    templateUrl: './consumer-identification.component.html',
    styleUrls: ['./consumer-identification.component.scss'],
})
export class ConsumerIdentificationModalComponent implements OnInit {

    @ViewChild('Consumerpdf', { static: false }) Consumerpdf: ElementRef;

    public Data: any;

    public Code: string = "";

    public CardNumber: string = "";

    private showLoading: Function;
    private dismissLoading: Function;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController
    ) {

        this.Data = this.NavParams?.get('data') || [];
        this.showLoading = this.NavParams?.get('showLoading') || null;
        this.dismissLoading = this.NavParams?.get('dismissLoading') || null;

        const code: string = StringUtils.RemoveWhiteSpace(this.Data?.WalletCard?.Number || null);

        this.Code = code
            ? StringUtils.EncodeQRString(JSON.stringify({ t: EnumQRCodeType.Card, v: code, d: new Date().toISOString() }))
            : '';

        this.CardNumber = code ? StringUtils.FormatToCreditCardNumber(code) : '';
    }

    ngOnInit() { }



    Close() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }


    async GeneratePdf(ev?: any) {


        ev?.preventDefault();
        ev?.stopPropagation();

        const element = this.Consumerpdf.nativeElement;

        if (!element) return;

        if (this.showLoading)
            await this.showLoading();

        // Captura o conteúdo como imagem de alta resolução
        const canvas = await html2canvas(element, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');

        const imgWidthPx = canvas.width;
        const imgHeightPx = canvas.height;
        const imgAspectRatio = imgWidthPx / imgHeightPx;

        // Define PDF A4
        const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Define margens (em mm)
        const margin = 20;
        const usableWidth = pageWidth - margin * 2;
        const usableHeight = pageHeight - margin * 2;
        const pageAspectRatio = usableWidth / usableHeight;

        let renderWidth: number, renderHeight: number, x: number, y: number;

        // Mantém proporção e respeita margens
        if (imgAspectRatio > pageAspectRatio) {
            renderWidth = usableWidth;
            renderHeight = renderWidth / imgAspectRatio;
        } else {
            renderHeight = usableHeight;
            renderWidth = renderHeight * imgAspectRatio;
        }

        // Centraliza o conteúdo dentro das margens
        x = (pageWidth - renderWidth) / 2;
        y = (pageHeight - renderHeight) / 2;

        // Adiciona imagem capturada
        pdf.addImage(imgData, 'PNG', x, y, renderWidth, renderHeight);

        const today = new Date().getTime();
        const textfooter = `${today}/${this.Code}`;

        pdf.saveGraphicsState(); // guarda o estado gráfico atual
        pdf.setFontSize(6);
        pdf.text(textfooter, 10, pageHeight - 10); // margem esquerda e fundo da página
        pdf.restoreGraphicsState(); // restaura o estado original


        if (this.dismissLoading)
            await this.dismissLoading();

        // Guarda o ficheiro
        pdf.save(`identidade_cartao_${new Date().getTime()}.pdf`);
    }
}
